var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 5H6V7H11V5Z",
    fill: "#5541D7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 8H21V2H2V10H3V14H2V22H21V16H22V8ZM20 14H17V10H20V14ZM19 8H16V4H19V8ZM4 4H14V8H4V4ZM5 10H15V14H5V10ZM4 16H14V20H4V16ZM19 20H16V16H19V20Z",
    fill: "#5541D7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 11H7V13H12V11Z",
    fill: "#5541D7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 17H6V19H11V17Z",
    fill: "#5541D7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.0421163271757ebd22273815ece6974d.svg";
export { ForwardRef as ReactComponent };